/**
 * 图片抠图操作栏坐标换算
 *
 * 将旋转后的图层包围盒转换为长画布全局坐标，供视口层的操作按钮水平定位使用。
 */

import type { IFramework } from '@/framework';
import { getLayerInfoWithRotate } from '@/utils/layer-kit';
import type { ILayerProps, IPosition, ISize } from '@/version-types';

/**
 * 获取抠图操作栏绑定的全局画布坐标
 *
 * @param framework - 编辑器 Framework 实例
 * @param layer - 操作栏绑定的原始图层
 * @returns 已叠加所属 Frame 纵向偏移且不再旋转的水平包围盒
 */
export const getCutoutOperateLayer = (
    framework: IFramework,
    layer: ILayerProps,
): ISize & IPosition & { rotate?: number } => {
    const frameOffsetTop = framework.service.transform.calcLayerOffsetTop(layer);
    // getBaseInfo 使用旋转后的左上角锚点，操作栏应使用水平外接矩形，避免跟随图层旋转。
    const layerInfo = getLayerInfoWithRotate(layer);
    return {
        ...layerInfo,
        top: layerInfo.top + frameOffsetTop,
        rotate: 0,
    };
};
